import { captureException } from "@sentry/react"

const COGNITO_IGNORE_ERROR_CODES = [
    "NetworkError",
    "CodeMismatchException",
    "ExpiredCodeException",
    "UserNotFoundException",
    "UsernameExistsException",
    "LimitExceededException"
]

export const reportError = (...args: Parameters<typeof captureException>) => {
    const [error, ctx] = args

    // exclude cognito errors triggered by wrong user action
    const shouldIgnore =
        typeof error === "object" &&
        error !== null &&
        "code" in error &&
        COGNITO_IGNORE_ERROR_CODES.includes((error as any).code)

    if (error !== undefined) {
        console.warn(error)
    }

    if (window.navigator.onLine && !shouldIgnore) {
        captureException(error, ctx)
    }
}
